import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Tools.module.scss';

export const ToolsStepOne = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.toolsLeftSection}>
        <span className={styles.toolsStepLeft_1}>TransparenTerra’s</span>
        <span className={styles.toolsStepLeft_2}>Tools</span>
        <span className={styles.toolsStepLeft_3}>and</span>
        <span className={styles.toolsStepLeft_4}>principles</span>
      </div>
    }
    rightContent={
      <div className={styles.toolsStepContentWrapper}>
        <p style={{ marginBottom: 28 }}>
          On TransparenTerra, transparency and trustworthy validation of data provide the basis for
          ultimate trust. To make them available, we’ve designed and assembled a pool of convenient
          digital tools and solutions, including:
        </p>
        <p>
          - An ESG score calculator;
          <br />
          - Environmental footprint calculators;
          <br />
          - Circular economy tools;
          <br />
          - A Trustworthy traceability system;
          <br />
          - A sustainable Marketplace;
          <br />
          - An NFT/NFA platform;
          <br />
          - TT chat;
          <br />- Blockchain Notarization.
        </p>
      </div>
    }
  />
);
